import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=16bac7ab"
import script from "./IconDownload.vue?vue&type=script&lang=ts"
export * from "./IconDownload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports